import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfidence99 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.79484 6.2644C3.31388 7.95155 2.41602 10.1632 2.41602 12.5845",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.55664 14.2285C3.02204 16.921 4.6108 19.2287 6.82276 20.6514",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5918 21.0001C19.1057 19.6257 20.9361 17.1576 21.4434 14.2356",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5858 12.5846C21.5858 10.2617 20.7595 8.13186 19.3848 6.4729",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4125 5.46017C16.7142 3.93081 14.4662 3 12.0008 3C9.67411 3 7.54101 3.82908 5.88086 5.20794",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.87 9.05C9.59 9.05 10.1833 9.30667 10.65 9.82C11.1167 10.3267 11.35 10.99 11.35 11.81C11.35 12.93 11.01 13.9 10.33 14.72C9.65 15.5333 8.76667 16.0433 7.68 16.25L7.28 15.15C8.56667 14.7967 9.40333 14.1567 9.79 13.23L9.78 13.22C9.39333 13.4333 8.96667 13.54 8.5 13.54C7.90667 13.54 7.41 13.3433 7.01 12.95C6.61 12.5567 6.41 12.02 6.41 11.34C6.41 10.6667 6.64333 10.1167 7.11 9.69C7.57667 9.26333 8.16333 9.05 8.87 9.05ZM7.74 11.36C7.74 11.6667 7.84 11.9167 8.04 12.11C8.24 12.3033 8.51333 12.4 8.86 12.4C9.32 12.4 9.71667 12.1967 10.05 11.79V11.7C10.05 11.2733 9.94 10.93 9.72 10.67C9.5 10.41 9.22333 10.28 8.89 10.28C8.55 10.28 8.27333 10.3867 8.06 10.6C7.84667 10.8067 7.74 11.06 7.74 11.36ZM15.4021 9.05C16.1221 9.05 16.7155 9.30667 17.1821 9.82C17.6488 10.3267 17.8821 10.99 17.8821 11.81C17.8821 12.93 17.5421 13.9 16.8621 14.72C16.1821 15.5333 15.2988 16.0433 14.2121 16.25L13.8121 15.15C15.0988 14.7967 15.9355 14.1567 16.3221 13.23L16.3121 13.22C15.9255 13.4333 15.4988 13.54 15.0321 13.54C14.4388 13.54 13.9421 13.3433 13.5421 12.95C13.1421 12.5567 12.9421 12.02 12.9421 11.34C12.9421 10.6667 13.1755 10.1167 13.6421 9.69C14.1088 9.26333 14.6955 9.05 15.4021 9.05ZM14.2721 11.36C14.2721 11.6667 14.3721 11.9167 14.5721 12.11C14.7721 12.3033 15.0455 12.4 15.3921 12.4C15.8521 12.4 16.2488 12.1967 16.5821 11.79V11.7C16.5821 11.2733 16.4721 10.93 16.2521 10.67C16.0321 10.41 15.7555 10.28 15.4221 10.28C15.0821 10.28 14.8055 10.3867 14.5921 10.6C14.3788 10.8067 14.2721 11.06 14.2721 11.36Z",
			fill: "var(--label-color, #475B5E)"
		})
	]
});
export default SvgConfidence99;
